import { get } from 'lodash';

import { IBaseEntityType } from '../types/entities/base/base.type';

/**
 * Format user display name as "last_name, first_name".
 */
export const formatUserDisplayName = (user: IBaseEntityType): string => {
  const firstName: string = get(user, 'first_name', '');
  const lastName: string = get(user, 'last_name', '');

  return lastName && firstName
    ? `${lastName}, ${firstName}`
    : lastName || firstName;
};
